import { useTranslation } from 'react-i18next'

import Button from '../../../../../Button'
import { FormActions } from '../../../../../Form'
import { QA_NAME_LISTING_FORM_SAVE_DRAFT } from '../../RentalPortalListingsForm.constants'

import DraftIcon from '../../../../../../icons/note-2.svg'

function ListingsFormActions({
  hasSaveDraft,
  isSavingDraft,
  isSubmitting,
  saveDraftDisabled,
  onSaveDraft,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <FormActions {...restProps} isSubmitting={isSubmitting}>
      {hasSaveDraft ? (
        <Button.Flat
          beforeIconProps={{ Icon: DraftIcon }}
          disabled={isSubmitting || saveDraftDisabled}
          isLoading={isSavingDraft}
          qaName={QA_NAME_LISTING_FORM_SAVE_DRAFT}
          text={t('RentalPortal.ListingFormTimingDraftKey')}
          onClick={onSaveDraft}
        />
      ) : null}
    </FormActions>
  )
}

export default ListingsFormActions
